import { render } from "./Loader.vue?vue&type=template&id=6390e386"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/components/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6390e386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6390e386', __exports__)) {
    api.reload('6390e386', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=6390e386", () => {
    api.rerender('6390e386', render)
  })

}


export default __exports__